import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import BundlesCommon from './BundlesCommon';

export default function TabBundles() {
    return (
        <>
            <EfSpec></EfSpec>
            <EfTitle>Choose your solution</EfTitle>
            <BundlesCommon></BundlesCommon>

            <EfSpec></EfSpec>
        </>
    );
}
